import React, { useState } from 'react';
import './NotFound.scss';

import { ErrorMessage } from '../../../Constants/Messages';

import {
    Icon,
    Box,
} from "@mui/material";

import {
    DoNotDisturbAlt,
} from '@mui/icons-material';

const NotFound = () => {
    // Use states
    // const [username, setUsername] = useState(null);

    //Variables

    // Event Handler Fuctions
    
    //Render Functions
    return <div className="pageNotFoundContainer">
        <div className="pageNotFoundContent">
            <Icon className="pageNotFoundIcon">
                <DoNotDisturbAlt />
            </Icon>
            <Box className="pageNotFoundText">
                {ErrorMessage.PAGE_NOT_FOUND}
            </Box>
        </div>
    </div>;
}

export default NotFound;
